import ApiBase from './ApiBase';
import axios from 'axios';

/**
 * FundInvestorTag API
 */
class FundInvestorTagApi extends ApiBase {
  /**
   * Check if Fund-Investor Tag name already exists
   * @param {*} fundInvestorTagName
   */
  async checkIfNameExists(fundInvestorTagName) {
    const request = {
      url: `${this.API_URL}/fundinvestortag?name=${fundInvestorTagName}`,
      headers: this.getHeaders(),
      method: 'HEAD',
      validateStatus: function(status) {
        return status === 200 || status === 403 || status === 404;
      }
    };

    const response = await axios.request(request);

    if (response.status === 200 || response.status === 403) {
      return true;
    } else if (response.status === 404) {
      return false;
    } else {
      throw Error('An error has occurred');
    }
  }

  async create(payload) {
    const request = {
      url: `${this.API_URL}/fundinvestortag`,
      method: 'POST',
      headers: this.getHeaders(),
      data: payload
    };

    const response = await axios.request(request);
    return response.data;
  }

  async update(payload, id) {
    const request = {
      url: `${this.API_URL}/fundinvestortag?id=${id}`,
      headers: this.getHeaders(),
      method: 'PUT',
      data: JSON.stringify(payload)
    };

    const response = await axios.request(request);

    return response.data;
  }

  async getAll() {
    const request = {
      url: `${this.API_URL}/fundinvestortags`,
      headers: this.getHeaders(),
      method: 'GET'
    };

    const response = await axios.request(request);

    return response.data;
  }

  async validateImportFromExcel(payload) {
    const request = {
      url: `${this.API_URL}/fundinvestortag/validateimport`,
      method: 'POST',
      headers: this.getHeaders(),
      data: payload
    };
    const response = await axios.request(request);
    return response.data;
  }

  async downloadInvestorTagImportTemplate() {
    const request = {
      url: `${this.API_URL}/fundinvestortag/import/template`,
      method: 'GET',
      headers: this.getHeaders(),
      responseType: 'blob'
    };

    const response = await axios.request(request);
    return response.data;
  }

  async importInvestorTagFromExcel(payload) {
    const request = {
      url: `${this.API_URL}/fundinvestortag/importexcel`,
      method: 'POST',
      headers: this.getHeaders(),
      data: payload
    };
    const response = await axios.request(request);
    return response.data;
  }
}

export default new FundInvestorTagApi();
